export  const config = import.meta.env.VITE_API_KEY;
  
   
  

